var map = {
	"./banner.vue": "1c8d",
	"./home_bargain.vue": "2174",
	"./home_comb.vue": "f76b",
	"./home_coupon.vue": "9ee9",
	"./home_goods_list.vue": "1c3e",
	"./home_hot.vue": "b604",
	"./home_hotranking.vue": "6bc5",
	"./home_menu.vue": "4cee",
	"./home_news_roll.vue": "b870",
	"./home_pink.vue": "f5b5",
	"./home_plant.vue": "364a",
	"./home_presell.vue": "fbd3",
	"./home_seckill.vue": "7ad6",
	"./home_service.vue": "58b4",
	"./home_shop.vue": "deca",
	"./home_title.vue": "96ae",
	"./home_topic.vue": "4d0a",
	"./nav_bar.vue": "eacf",
	"./picture_cube.vue": "629f",
	"./search_box.vue": "1364",
	"./wechat_live.vue": "244d",
	"./z_auxiliary_box.vue": "c08c",
	"./z_auxiliary_line.vue": "344a",
	"./z_ueditor.vue": "7946",
	"./z_wechat_attention.vue": "20ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99ae";